import { styled, Box, Typography } from '@mui/material';

const ProfileCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '50px',
  alignItems: 'center',
  gap: '20px',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '30px',
  },
  [theme.breakpoints.up('lg')]: {
    gap: '40px',
  },
}));

const ProfileImage = styled('img')(({ theme }) => ({
  width: '150px',
  height: '200px',
  objectFit: 'cover',
  flexShrink: 0,
  [theme.breakpoints.up('lg')]: {
    width: '165px',
    height: '220px',
  },
}));

const ProfileContent = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

const ProfileName = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 'bold',
  marginBottom: '10px',
  color: theme.palette.primary.navy || '#000',
  [theme.breakpoints.up('lg')]: {
    fontSize: '22px',
  },
}));

const ProfileText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.primary.navy || '#333',
  lineHeight: 1.6,
  textAlign: 'justify',
  '& .quote': {
    fontStyle: 'italic',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '17px',
  },
}));

export const ProfileCard = ({ image, name, title, children }) => {
  return (
    <ProfileCardContainer>
      <ProfileImage src={image} alt={name} />
      <ProfileContent>
        <ProfileName>
          {name}
          {title && `, ${title}`}
        </ProfileName>
        <ProfileText>{children}</ProfileText>
      </ProfileContent>
    </ProfileCardContainer>
  );
};
